/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { JSONSchema6 } from 'json-schema'
import { asNumber, guessType } from 'react-jsonschema-form/lib/utils'
import { isArray, isBoolean } from 'util'

const numberTypes = new Set(['number', 'integer'])
const hasNumericItems = (items: JSONSchema6['items']) =>
  items && !isBoolean(items) && !isArray(items) && numberTypes.has(items.type as string)

/**
 * This is a silly limitation in the DOM where option change event values are
 * always retrieved as strings.
 */
const parseValue = (schema: JSONSchema6, value: any) => {
  const { type, items, enum: enumValues } = schema

  if (value === '') {
    return undefined
  }
  if (type === 'array' && hasNumericItems(items)) {
    return value.map(asNumber)
  }
  if (type === 'boolean') {
    return value === 'true'
  }
  if (type === 'number') {
    return asNumber(value)
  }

  // If type is undefined, but an enum is present, try and infer the type from
  // the enum values
  if (enumValues) {
    if (enumValues.every((x: any) => guessType(x) === 'number')) {
      return asNumber(value)
    }
    if (enumValues.every((x: any) => guessType(x) === 'boolean')) {
      return value === 'true'
    }
  }

  return value
}
export default parseValue
